<template>

    <div class="nsb" v-show="showBloc">
        <div class="lucky">
            <p class="f-title">{{ $t('fetch_bottom_sheet_cta_ok') }}</p>
            <p class="f-text">{{ $t('fetch_switch_description') }}</p>
        </div>
        <div class="unlucky" @click="toggleSwitch(!switchNotifValue)">
            <lottie-loader v-if="switchNotifLoader" :size="24"></lottie-loader>
            <img :src="switchImg" v-else>
        </div>
    </div>

</template>

<script>
import LottieLoader from '../components/lottie/LottieLoader'

import Notifs from '../modules/notifications'

export default {

    name: 'notifications-ask-bloc',

    components: {LottieLoader},

    computed: {

        switchImg() {
            return this.switchNotifValue ? '/img/fetch/switch-on.svg' : '/img/fetch/switch-off.svg'
        }
    },

    data() {
        return {
            switchNotifValue: false,
            switchNotifLoader: false,
            showBloc: false
        }
    },

    mounted() {

        if(!Notifs.isDenied()) {
            this.showBloc = true
        }
    },

    methods: {

        toggleSwitch(bool) {

            this.switchNotifLoader = true

            if (!Notifs.isGranted()) {

                Notifs.requestPermission()
                    .finally(() => {

                        if (Notifs.isGranted()) {

                            this.updateNotifs(bool)

                        }
                    })
            } else {
                this.updateNotifs(bool)
            }
        },

        updateNotifs(bool) {
            Notifs.update({important: bool, news: bool})
                .then(result => {
                    this.switchNotifValue = result.notifications.push.important
                })
                .finally(() => {
                    this.switchNotifLoader = false
                })
        }
    }
}

</script>

<style lang="scss" scoped>

.nsb {
    width: 100%;
    padding: 16px 8px;
    display: flex;
    flex-direction: row;
    background-color: $white;
    border-radius: 12px;

    @media screen and (min-width: $above-tablet-length) {
        max-width: 480px;
    }

    > div {
        margin: 0 8px;
    }

    .lucky {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: start;

        .f-title {
            font-size: 15px;
            font-weight: 600;
            line-height: 20px;
        }

        .f-text {
            color: $neutralsMoon;
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
        }
    }

    .unlucky {
        width: 46px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
}
</style>
